import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import { ICountry } from 'services/enums/types';
import './CountrySearchCard.scss';

interface ICountrySearchCardProps {
  country: ICountry;
  isSelected?: boolean;
  onClick?: (country: ICountry) => void;
}

const CountrySearchCard = ({ country, isSelected, onClick }: ICountrySearchCardProps) => {
  const { t, i18n } = useTranslation();

  const countryName =
    t(`countries.${country.codeAlfa2}`) !== `countries.${country.codeAlfa2}`
      ? t(`countries.${country.codeAlfa2}`)
      : i18n.language === 'pl'
        ? country.polishName
        : country.englishName;

  return (
    <div
      className={classNames('country-search-card', { isSelected })}
      onClick={() => onClick && onClick(country)}
    >
      <img
        src={`https://flagsapi.com/${country.codeAlfa2}/flat/32.png`}
        className="min-w-[32px] rounded"
      />
      <div className="country-search-card-header">
        <div className="country-search-card-header-title">{countryName}</div>
        {/* <div className="country-search-card-header-description">
          <div className="country-search-card-header-description-content">
            <span>{country.codeAlfa2}</span>
            <PiCircleFill />
            <span>{country.codeAlfa3}</span>
            <PiCircleFill />
            <span>{country.englishName}</span>
          </div>
        </div> */}
      </div>

      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default CountrySearchCard;
